// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__17EBB","loaderOuter":"PageOverlayLoader_loaderOuter__2AYok"};